import { Store, Tag } from "lucide-react";
import { PulseHeader } from "./PollCard";

export function OfferCard({ pulse }) {
  const { business, description, discount_pct } = pulse.payload;
  return (
    <article
      className="q-glass rounded-3xl p-5 space-y-4 relative overflow-hidden"
      data-testid={`pulse-offer-${pulse.id}`}
      style={{
        borderColor: "rgba(225,29,72,0.35)",
      }}
    >
      <span
        className="pointer-events-none absolute -top-16 -right-16 h-40 w-40 rounded-full"
        style={{ background: "radial-gradient(circle, var(--accent-soft), transparent 70%)" }}
        aria-hidden="true"
      />
      <PulseHeader pulse={pulse} kind="Flash Offer" />

      <div className="grid grid-cols-[1fr_auto] items-center gap-4">
        <div className="min-w-0">
          <div className="flex items-center gap-2 text-slate-400 text-xs font-mono uppercase tracking-widest">
            <Store size={12} /> Negocio
          </div>
          <div
            className="font-display text-2xl sm:text-3xl font-bold text-slate-100 leading-tight mt-1"
            data-testid={`offer-business-${pulse.id}`}
          >
            {business}
          </div>
        </div>
        <div
          className="rounded-2xl q-accent-bg text-[color:var(--accent-contrast)] px-4 py-3 text-center shadow-[0_0_24px_var(--accent-glow)]"
          data-testid={`offer-discount-${pulse.id}`}
        >
          <div className="font-display text-3xl font-bold leading-none">-{discount_pct}%</div>
          <div className="text-[10px] uppercase tracking-widest font-mono mt-0.5">Descuento</div>
        </div>
      </div>

      <p className="text-sm text-slate-200 leading-relaxed">{description}</p>

      <div className="flex items-center justify-between pt-1">
        <span className="q-chip">
          <Tag size={12} /> Oferta flash · 24 h
        </span>
      </div>
    </article>
  );
}
